module.exports = __webpack_public_path__ + "static/media/jimmy-jimmy-1484794.346a61ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Imgs/jimmy-jimmy-1484794.jpg
// module id = 73
// module chunks = 0